import UserLoginInfoSettingsStore from './UserLoginInfoSettingsStore'

export default UserLoginInfoSettingsStore
